var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"escape-the-rut"},[_c('p',{staticClass:"text"},[_vm._v("Scroll to escape the fruit rut.")]),_c('scroll-down-arrow',{staticClass:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }